const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SellerPortalProductQuery: any = {
    GetSearchBrands: `${Backofficebff}/v1/SellerPortalProduct/search-brands`,
};